import Vue from 'vue'
import Router from 'vue-router'

import Home from '../pages/Home'
import SignIn from '../pages/authentication/SignIn'
import ConfirmEmail from "../pages/authentication/ConfirmEmail";
import Events from '../pages/Events'
import Drivers from '../pages/Drivers'
import Addresses from '../pages/Addresses'
import Users from '../pages/Users'
import MyAccount from '../pages/MyAccount'
import Reporting from '../pages/Reporting'
import PasswordRecovery from "../pages/authentication/PasswordRecovery";
import store from "../store/index"

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: { authorize: ['Administrator','Coordinator'] }
    },
    {
      path: '/authentication/signin',
      name: 'signin',
      component: SignIn
    },
    {
      path: '/authentication/confirm-email',
      name: 'confirmEmail',
      component: ConfirmEmail
    },
    {
      path: '/authentication/password-recovery',
      name: 'passwordRecovery',
      component: PasswordRecovery
    },
    {
      path: '/events',
      name: 'events',
      component: Events,
      meta: { authorize: ['Administrator','Coordinator'] }
    },
    {
      path: '/drivers',
      name: 'drivers',
      component: Drivers,
      meta: { authorize: ['Administrator','Coordinator'] }
    },
    {
      path: '/addresses',
      name: 'addresses',
      component: Addresses,
      meta: { authorize: ['Administrator','Coordinator'] }
    },
    {
      path: '/users',
      name: 'users',
      component: Users,
      meta: { authorize: ['Administrator'] }
    },
    {
      path: '/myaccount',
      name: 'myaccount',
      component: MyAccount,
      meta: { authorize: ['Administrator','Coordinator'] }
    },
    {
      path: '/reporting',
      name: 'reporting',
      component: Reporting,
      meta: { authorize: ['Administrator','Coordinator'] }
    },
    { path: '*', redirect: '/' }
  ],
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 }
  },
})

router.beforeEach(async (to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const { authorize } = to.meta;
  let currentUser = store.getters.currentUser;
  store.commit('CLEAN_ALERTS');
  if (!currentUser && store.getters.refreshToken){
    await store.dispatch("refresh");
    currentUser = store.getters.currentUser;
  }

  if (authorize) {
    if (!currentUser) {
      // not logged in so redirect to login page with the return url
      return next({ name: 'signin' });
    }
    
    for (let role of currentUser.role){
      if (authorize.includes(role)){
        return next();
      }
    }
    return next({ path: '/' });
  }
  
  next();
})

export default router
